<div class="video-call-container">
  <div class="video-container" #videoContainer>
    <div class="local-video-container" [ngStyle]="{ 'width': feeds.length <= 3 ? (100 / feeds.length + '%') : '33.3%' }">
      <video
        #localVideo
        id="localVideo"
        [ngClass]="{ 'hide-video': isLocalVideoMuted, 'show-video': !isLocalVideoMuted }"
        autoplay
        playsinline
      ></video>
      <div *ngIf="isLocalVideoMuted" class="no-video-placeholder">
        <img src="assets/images/chatroom/video-camera-slash_white.svg" />
        <p>{{'WEBCLIENT.CHATROOM.VIDEO_CALL.TURNED_OFF_CAM' | translate}}</p>
      </div>
      <audio hidden #localAudio autoplay playsinline></audio>
    </div>

    <ng-container *ngIf="feeds.length > 1">
      <ng-container *ngFor="let rf of feeds">
        <div class="remote-video-container" *ngIf="rf && !!rf.rfindex" [ngStyle]="{ 'width': feeds.length <= 3 ? (100 / feeds.length + '%') : '33.3%' }">
            <video
            #remoteVideo
            [ngClass]="{ 'hide-video': rf.isRemoteVideoMuted, 'show-video': !rf.isRemoteVideoMuted}"
            [id]="'remoteVideo' + rf.rfindex + '-video'"
            autoplay
            playsinline
          ></video>
          
          <audio hidden #remoteAudio [id]="'remoteAudio' + rf.rfindex + '-audio'" autoplay playsinline></audio>
    
          <div *ngIf="rf.isRemoteVideoMuted" class="no-video-placeholder">
            <ng-container>
              <!-- <img src="assets/images/chatroom/video-camera-slash_white.svg" /> -->
              <div class="avatar-wrapper">
                <div class="avatar" [ngStyle]="{ 'background-image': rf.userInfo.avatarImageSrc }"></div>
              </div>

              <p class="avatar-name">{{ rf.userInfo.name }}</p>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>

  <div
    class="video-call-btn-wrapper"
    [ngStyle]="{ 'opacity': isButtonGpShowing ? '1' : '0' }"
    (mouseenter)="onMouseEnter($event)"
    (mouseleave)="onMouseLeave($event)"
  >
    <div class="video-call-timer">
      <ng-container *ngIf="isGroup">
        <i class="fa fa-user-o" aria-hidden="true" style="font-size: 14px"></i>
        <span style="color: white; margin-bottom: 20px">
          {{ feeds.length === 0 ? 1 : feeds.length }}
        </span>
      </ng-container>

      <ng-container>
        <div *ngIf="feeds.length > 1" class="clock-container">
          <i class="fa fa-clock-o" aria-hidden="true" style="margin-left: 10px"></i>
          <span *ngIf="getVideoCallTime() as vc"> {{ vc.hours }} h {{ vc.minutes }} m {{ vc.seconds }} s </span>
        </div>
      </ng-container>
    </div>

    <div class="video-room-status">
      <ng-container *ngIf="isCallByMe">
        <span style="color: white" *ngIf="!isGroup && feeds.length === 0"> is ringing... </span>
        <div style="color: white" *ngIf="isGroup && (feeds.length === 0 || feeds.length === 1)">
          {{'WEBCLIENT.CHATROOM.VIDEO_CALL.WAITING_TO_JOIN' | translate}}...
        </div>
      </ng-container>
    </div>

    <div class="video-call-btn-group">
      <button
        type="button"
        [ngStyle]="{ 'background-color': !isAudioMuted ? 'white' : 'rgba(204, 204, 204, .49)' }"
        (click)="toggleAudio()"
      >
        <i class="fa fa-fw" [ngClass]="{ 'fa-microphone': !isAudioMuted, 'fa-microphone-slash': isAudioMuted }"></i>
      </button>
      <button
        type="button"
        [ngStyle]="{ 'background-color': !isLocalVideoMuted ? 'white' : 'rgba(204, 204, 204, .49)' }"
        (click)="toggleWebcam()"
      >
        <!-- <i class="fa fa-fw" [ngClass]="{'fa-video-camera': !isLocalVideoMuted, 'fa-video-slash': isLocalVideoMuted}"></i> -->
        <i class="fa fa-fw fa-video-camera" *ngIf="!isLocalVideoMuted; else videoslash"></i>
        <ng-template #videoslash>
          <img src="assets/images/chatroom/video-camera-slash_black.svg" style="width: 17px" />
        </ng-template>
      </button>
      <button
        type="button"
        [ngStyle]="{ 'background-color': !isSoundMuted ? 'white' : 'rgba(204, 204, 204, .49)' }"
        (click)="toggleSound()"
      >
        <i class="fa fa-fw" [ngClass]="{ 'fa-volume-up': !isSoundMuted, 'fa-volume-off': isSoundMuted }"></i>
      </button>
    </div>
    <button class="stop-video-call-btn" type="button" (click)="endVideoCall()">
      <i class="fa fa-phone fa-fw"></i>
    </button>
    <!-- <button type="button" (click)="test()">test</button> -->
  </div>
</div>
